// extracted by mini-css-extract-plugin
module.exports = {"baseSize":"BaseSize_baseSize__2TvH0","size":"BaseSize_size__3iHU6","title":"BaseSize_title__gN2Lz"};